import * as wasmBindgen from "../wasm/sd";
/**
 * Singlethreaded debug build MmdWasmInstanceType
 *
 * Requirements for use:
 *
 * - Browser that supports WebAssembly
 */
export class MmdWasmInstanceTypeSD {
    getWasmInstanceInner() {
        return wasmBindgen;
    }
}
